import { CategoryData } from '../../../../types/types';

export const nourriture: CategoryData = {
    // Boissons fondamentales
    'mw': {
        translation: 'Eau',
        translationEn: 'Water',
        illustration: '𓈖',
    },
    'ḥnqt': {
        translation: 'Bière – Boisson de base, offrande essentielle aux dieux',
        translationEn: 'Beer – Staple drink, essential offering to the gods',
        illustration: '𓎛𓈖𓏏',
    },
    'jrp': {
        translation: 'Vin – Issu des vignobles du Delta',
        translationEn: 'Wine – From the vineyards of the Delta',
        illustration: '𓇋𓂋𓊪',
    },

    // Aliments de base
    't': {
        translation: 'Pain – Nourriture fondamentale des Égyptiens',
        translationEn: 'Bread – Staple food of the Egyptians',
        illustration: '𓏏',
    },
    'jf': {
        translation: 'Viande – Offrande aux dieux et nourriture des élites',
        translationEn: 'Meat – Offering to the gods and food of the elites',
        illustration: '𓄑𓄔',
    },
    'rmt': {
        translation: 'Poisson – Pêché dans le Nil, abondant et quotidien',
        translationEn: 'Fish – Caught in the Nile, abundant and eaten daily',
        illustration: '𓆠',
    },
    'ꜣpdw': {
        translation: 'Volaille / Canard – Élevé ou chassé dans les marais',
        translationEn: 'Poultry / Duck – Raised or hunted in the marshes',
        illustration: '𓅭',
    },
    'swḥt': {
        translation: 'Œuf',
        translationEn: 'Egg',
        illustration: '𓋴𓅱𓎛𓏏𓆇',
        reading: 'Lecture analytique — swḥt (S29-G43-V28-X1-H8), « œuf ». S29 porte s, G43 porte w, V28 porte ḥ, X1 marque le féminin (t), et H8 est le déterminatif de l\'œuf. Descendance copte directe : saïdique ⲥⲟⲟⲩϩⲉ, bohaïrique ⲥⲱⲟⲩϩⲓ, « œuf ».',
        readingEn: 'Analytical reading — swḥt (S29-G43-V28-X1-H8), "egg". S29 carries s, G43 carries w, V28 carries ḥ, X1 marks the feminine (t), and H8 is the determinative for egg. Direct Coptic descendant: Sahidic ⲥⲟⲟⲩϩⲉ, Bohairic ⲥⲱⲟⲩϩⲓ, "egg".'
    },

    // Fruits et douceurs
    'bỉt': {
        translation: 'Miel / Abeille – Seul édulcorant connu des anciens Égyptiens',
        translationEn: 'Honey / Bee – The only sweetener known to the ancient Egyptians',
        illustration: '𓆾',
    },
    'bnr': {
        translation: 'Dattes – Fruit doux et sucré du palmier (bnr = doux)',
        translationEn: 'Dates – Sweet fruit of the palm tree (bnr = sweet)',
        illustration: '𓃀𓈖𓂋',
        reading: 'Lecture analytique — bnr (D58-N35-D21), « datte, palmier-dattier ». D58 porte b, N35 porte n, D21 porte r.',
        readingEn: 'Analytical reading — bnr (D58-N35-D21), "date, date palm". D58 carries b, N35 carries n, D21 carries r.'
    },
    'ỉꜣrr.t': {
        translation: 'Raisin – Cultivé pour le vin dans le Delta',
        translationEn: 'Grapes – Grown for wine in the Delta',
        illustration: '𓇋𓄿𓂋𓂋𓏏',
    },
    'nḥt': {
        translation: 'Figues de sycomore – Arbre sacré, fruit offert aux morts',
        translationEn: 'Sycamore figs – Sacred tree, fruit offered to the dead',
        illustration: '𓇙𓏏',
    },

    // Céréales et huiles
    'šmꜥ.t': {
        translation: 'Orge / Blé – Base du pain et de la bière',
        translationEn: 'Barley / Wheat – The base of bread and beer',
        illustration: '𓌀𓅱𓏏',
    },
    'mrḥ.t': {
        translation: 'Huile / Graisse – Pour la cuisine et les onctions rituelles',
        translationEn: 'Oil / Fat – For cooking and ritual anointing',
        illustration: '𓏁𓈖',
    },
    'snṯr': {
        translation: 'Encens – Résine parfumée brûlée en offrande aux dieux',
        translationEn: 'Incense – Fragrant resin burned as an offering to the gods',
        illustration: '𓋴𓈖𓇯𓂋',
    }
};

export default nourriture;
